import url from './url';

async function getPlanosCurso(token, cdCurso) {

    let data = await fetch(`${url}/plano/curso/${cdCurso}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function getPlano(token, cdPlano) {

    let data = await fetch(`${url}/plano/show/${cdPlano}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function checkCursoAtivo(token, cdCurso) {

    let data = await fetch(`${url}/plano/check/curso/${cdCurso}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}



export { getPlanosCurso, getPlano, checkCursoAtivo }